import { inject, observer } from "mobx-react";
import React from "react";
import { Airplay, Headphones, Mic, MicOff, PenTool, XCircle, RotateCcw, Trash2 } from "react-feather";
import { Button, Spinner, UncontrolledTooltip, Popover } from "reactstrap";
import PresenterControlStore from "../../../stores/presenterControlStore";
import { CirclePicker } from "react-color";
import "../../../assets/scss/pages/app-chat.scss"

enum IAudioStatus {
  NotConnected = "NOT_CONNECTED",
  Connecting = "CONNECTING",
  Connected = "CONNECTED",
  Muted = "MUTED"
}

const colors:any = {
  0: '#28c76f',
  1: '#9addf7',
  2: '#abbbf1',
  3: '#bc98eb',
  4: '#cd76ef',
  5: '#de54df',
  6: '#f6ca55',
  7: '#f35547',
  8: '#f039a0',
  9: '#ef32d9'
}

interface IPresenterControlsProp {
  sessionStore: any,
  presenterControlStore: PresenterControlStore,
  meeting: any,
  updateControl: any,
  undo: any,
  clear: any
}

interface IPresenterControlsState {
  markerActive: boolean,
  showColorPicker: boolean,
  color: string,
  popoverOpen: boolean
}

@inject("presenterControlStore", "sessionStore")
@observer
class PresenterControls extends React.Component<IPresenterControlsProp, IPresenterControlsState> {

  state = {
    markerActive: false,
    showColorPicker: false,
    color: "#28c76f",
    popoverOpen: false
  }

  componentDidMount() {
    const { presenterControlStore, meeting } = this.props;
    const {audioStatus } = presenterControlStore;
    if (meeting.useAudio) {
      if(audioStatus != IAudioStatus.Connected){ // for back navigation
        this.joinAudio();
      }
      //TODO: handle page refresh
    }
  }
  componentWillUnmount() {
    const { presenterControlStore, sessionStore,meeting } = this.props;
    //presenterControlStore.leaveAudio(firebase,sessionStore.authUser,meeting); //TODO: only unjoin on EndMeeting or browser close/network outage
  }

  togglePopover = () => {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    })
  }

  joinAudio = () =>{
    const {presenterControlStore, sessionStore, meeting} = this.props;
    // presenterControlStore.joinAudio(meeting.uid, meeting.presenter.audio.audioUid);
  }

  onClickMarker = (color: any, event: any) => {
    if (color == undefined) {
      this.props.updateControl("markerActive", this.state.markerActive)
    }
    else {
      this.togglePopover()
      this.props.updateControl("brushColor", color.hex)
    }
  }

  render() {
    const { presenterControlStore} = this.props;
    const { localAudioLevel, audioStatus } = presenterControlStore;
    const micColor:string = colors[Math.floor(localAudioLevel * 10)];
    

    const muteControl =
      audioStatus === IAudioStatus.Connected || audioStatus === IAudioStatus.Connecting ? (
          <Button id="muteCall"
            outline
            className="mr-1 mb-1 rounded-circle btn-icon"
            color={audioStatus === IAudioStatus.Connected ? "success" : "light"}
            onClick={() => presenterControlStore.muteAudio()}
          >
            {audioStatus === IAudioStatus.Connecting ? <Spinner size="10"/> : <Mic size={32} color={micColor} />}
            <UncontrolledTooltip placement="top" target="muteCall">
              Mute
          </UncontrolledTooltip>
          </Button>
        ) : null;

    const unmuteControl =
      audioStatus === IAudioStatus.Muted  ? (
          <Button id="unMuteCall"
            className="mr-1 mb-1 rounded-circle btn-icon"
            color="warning"
            onClick={() => presenterControlStore.unMuteAudio()}
          >
            <MicOff size={32} />
            <UncontrolledTooltip placement="top" target="unMuteCall">
              Unmute
          </UncontrolledTooltip>
          </Button>
        ) : null;

    const audioControls = audioStatus !== IAudioStatus.NotConnected ? (
      <React.Fragment>
        {muteControl}
        {unmuteControl}
      </React.Fragment>
    ) : (
        <React.Fragment>
          <Button className="mr-1 mb-1 round" color="relief-success"
            onClick={() => {
              this.joinAudio();
            }}>
            <Headphones size={20} />
            <span>Join Audio</span>
          </Button>
        </React.Fragment>
      );

    return (
      <React.Fragment>
        {/* {audioControls} */}
        <Button id="marker"
          outline
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="info"
          onClick={() => {this.onClickMarker}}
        >
          <PenTool size={234} />
        </Button>
        <Popover
          placement="top"
          target="marker"
          isOpen={this.state.popoverOpen}
          toggle={this.togglePopover}
          className="mt-18"
        >
          <div className="padding-8">
            <CirclePicker colors={colors} onChangeComplete={this.onClickMarker} />
          </div>
        </Popover>

        <Button id="undo"
          outline
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="success"
          onClick={(e) => { this.props.undo()}}
        >
          <RotateCcw size={24} />
          <UncontrolledTooltip placement="top" target="undo">
            Undo
          </UncontrolledTooltip>
        </Button>

        <Button id="clear"
          outline
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="warning"
          onClick={(e) => { this.props.clear()}}
        >
          <Trash2 size={24} />
          <UncontrolledTooltip placement="top" target="clear">
            clear
          </UncontrolledTooltip>
        </Button>



        {/* <Button id="whiteboard"
          outline
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="warning"
        >
          <Airplay size={24} />
          <UncontrolledTooltip placement="top" target="whiteboard">
            Whiteboard
          </UncontrolledTooltip>
        </Button> */}
      </React.Fragment>
    );
  }
}
export default PresenterControls;
